import {Component, HostListener, Input, OnInit } from '@angular/core';
import {BreakpointObserver} from "@angular/cdk/layout";
import {PermissionsService, RouteService} from "foo-framework";
import {ActivatedRoute, Router} from "@angular/router";
import {BreadcrumbService} from "xng-breadcrumb";

type Links = {
  route: string;
  id: string;
  permission?: string;
  label: string;
  state?: string;
  dataTarget: string;
  clearNavigationHistory?: boolean,
  icon: string;
  iconImage: string;
}[];

@Component({
  selector: 'foo-left-menu-navigator',
  templateUrl: './left-menu-navigator.component.html',
  styleUrls: ['./left-menu-navigator.component.scss']
})
export class LeftMenuNavigatorComponent implements OnInit {

  _links: Links = [];
  get links(): Links{
    return this._links;
  }

  @Input() params: any = {};

  @Input() set links(value : Links){
    this._links = value;
    const firstRouteIsALink = this.links.map(l => l.route).includes(this.routeService.routesHistory[0]);
    const secondRouteIsALink = this.links.map(l => l.route).includes(this.routeService.routesHistory[1]);
    if(firstRouteIsALink && secondRouteIsALink){
      this.breadcrumbService.set('@' + this.routeService.routesHistory[0], { skip: true });
    }
    this.activateFirstAvailableItem();
  };

  _permissions: any = [];
  get permissions(): any{
    return this._permissions;
  }

  @Input() set permissions(value : Links){
    this._permissions = value;
    this.activateFirstAvailableItem();
  };

  @Input() itemShimmer: boolean = false;

  menuClosed: boolean;


  @Input() showMenu = true;


  constructor(
    protected breakpointObserver: BreakpointObserver,
    protected routeService: RouteService,
    protected router: Router,
    protected permissionsService: PermissionsService,
    protected breadcrumbService: BreadcrumbService,
    public route: ActivatedRoute
  ) {
    this.menuClosed = this.route.snapshot.queryParams.menuClosed ? JSON.parse(this.route.snapshot.queryParams.menuClosed) : false;
    breakpointObserver
      .observe('(max-width: 769px)')
      .subscribe(({matches}) => {
        if(!this.menuClosed) {
          this.menuClosed = !!matches;
        }
      });
  }

  ngOnInit(): void {
  }

  toggleMenu(): void {
    this.menuClosed = !this.menuClosed;
    const params = {...this.route.snapshot.queryParams, 'menuClosed': this.menuClosed};
    this.router.navigate([], {queryParams: params});
  }

  checkIfActivatedRoute(route: string): boolean {
    let currentIndex = -1;
    let maxIndex = -1;
    this.links.forEach((item: any, idx: number) => {
      if (item.route === route) {
        currentIndex = this.routeService.routesHistory.findIndex(part => part === item.route);
      } else {
        maxIndex = Math.max(maxIndex, this.routeService.routesHistory.findIndex(part => part === item.route));
      }
    });
    return currentIndex !== -1 && currentIndex > maxIndex;
  }

  emptyRouteHistory(routeLink): void {
    if (routeLink.clearNavigationHistory) {
      this.routeService.routesHistory = [];
      this.router.navigate([`/${routeLink.route}`], {
        queryParams: this.params
      });
    } else if (!this.checkIfActivatedRoute(routeLink.route)) {
      this.params = {...this.route.snapshot.queryParams, ...this.params, 'menuClosed': this.menuClosed};
      const routes = this.links.map(link => link.route);
      const existingRouteIdx = this.routeService.routesHistory.findIndex(route => routes.includes(route));
      const firstRouteIsALink = this.links.map(l => l.route).includes(this.routeService.routesHistory[0]);

      if (firstRouteIsALink) {
        if(this.routeService.routesHistory[0] == routeLink.route){
          this.routeService.routesHistory = this.routeService.routesHistory.slice(0, 0);
        }else{
          this.routeService.routesHistory = this.routeService.routesHistory.slice(0, 1);
          this.breadcrumbService.set('@' + this.routeService.routesHistory[0], { skip: true });
        }
      }else if (existingRouteIdx !== -1) {
        this.routeService.routesHistory = this.routeService.routesHistory.slice(0, existingRouteIdx);
      }
      this.router.navigate([`/${routeLink.route}`], {
        queryParams: this.params
      });
    }
  }

  isStateExisted(state: string): boolean {
    // for testing purposes
    // return  true;
    return this.permissionsService.checkIfStateExist(state);
  }

  private activateFirstAvailableItem(): void {
    if (this.links && Object.keys(this.links).length > 0 && this.permissions && Object.keys(this.permissions).length > 0) {
      const firstAvailableLink = this.links.find(link =>
        (link.state && this.isStateExisted(link.state)) ||
        this.permissions[link.permission]?.can_read
      );

      const isAnyRouteActive: boolean = this.links.some(link => this.checkIfActivatedRoute(link.route) && ((link.state && this.isStateExisted(link.state)) ||
        this.permissions[link.permission]?.can_read));

      if (firstAvailableLink && !isAnyRouteActive) {
        this.emptyRouteHistory(firstAvailableLink);
      }
    }
  }
}
